import React, { Component } from 'react';
import '../Recharge.css';
import NumberFormat from 'react-number-format';
import ImageMakeNewRecharge from '../images/recharge-make-new-recharge.png';
import { clientInfo, transactionID } from '../../../services/helpers';
import moment from 'moment';
import axios from 'axios';

class InicialPage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            month: '',
            year: ''
        }

    }

    /* getLastRechart = async (year, month) => {

        try {
            const response = await axios.post('https://www.pagtel.com.br/Hub360Correios/v3/topUpHistory', {
                transactionId: transactionID('ACA'),
                msisdn: this.state.clientInfo.number,
                year: year,
                month: month
            })
            
            response
            
            .then((response) => {
                if (typeof response.data.details !== 'undefined' && response.data.code === 'P00') {
                    let output;
                    let recharge;
                    // console.log(response);
                    response.data.details.map((result) => {
                        let oldDate = '';
                        if (result.rechargeStatus === 'Sucesso' && (result.date > oldDate)) {
                            let oldDate = moment(result.date, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                            output = result;
                        }
                    });



                    if (!output) {
                        if (this.state.tryLastRechart < 2) this.tryAgainLastRechart();
                        return false;
                    }


                    recharge = {
                        number: this.formatPhone(this.state.clientInfo.number),
                        amount: output.rechargeValue,
                        paymentMethod: '',
                    }

                    this.setState({ lastRecharge: recharge, loading: 0 });

                } else {
                    if (this.state.tryLastRechart < 2) this.tryAgainLastRechart();
                }

                if (this.state.tryLastRechart === 2) this.setState({ loading: 0 });

            });

        }catch(exception){

        }

    } */

    render() {

        return (
            <div className="content-recharge-manager" >
                <div className="btn-back back-recarga-btn"><a href="#"> Voltar </a></div>
                <h1>Gerencie suas recargas</h1>

                <div className="container-manager-recharge">

                    <div className="box">
                        <img className="cursor-pointer" onClick={() => {this.props.step(1)}} style={{ marginTop: -3, marginBottom: -10 }} alt="" src={ImageMakeNewRecharge} />
                    </div>

                    <div className="box noimage">
                        <h3>Última recarga realizada</h3>
                        <div>
                            <div className="recharge-manager-item">
                                <div className="recharge-change-number-container">
                                    <small>Número</small>
                                </div>
                                <p className="recharge-change-number-text" >{clientInfo().number}</p>
                                <NumberFormat
                                    className="d-none recharge-change-number-input"
                                    type="text"
                                    name="number"
                                    format="(##) #####-####"
                                    placeholder="(99) 99999-9999"
                                    required
                                    onValueChange={(values) => {
                                        const { value } = values;
                                        this.setState({ lastRecharge: { ...this.state.lastRecharge, number: value } });
                                    }}
                                />
                            </div>

                            <div className="recharge-manager-item">
                                <div className="recharge-change-number-container">
                                    <small>Valor</small>
                                </div>
                                <p className="recharge-change-amount-text">R$10,00</p>
                                <select className="d-none recharge-change-amount-input" 
                                        onChange={(values) => {
                                            const value = values.target.value;
                                            this.setState({ lastRecharge: { ...this.state.lastRecharge, amount: value } });
                                        }
                                }>
                                </select>
                            </div>
                            <div className="recharge-manager-item text-center">
                                <button className="btn btn-success" onClick={() => { this.fastRecharge() }}>Recarregar</button>
                            </div>
                        </div>
                    </div>

                </div>



            </div>
        );
    }

}

export default InicialPage